import { render, staticRenderFns } from "./EmployeeContactsDetailForm.vue?vue&type=template&id=18a1ea73&scoped=true&"
import script from "./EmployeeContactsDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeContactsDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1ea73",
  null
  
)

export default component.exports